
import request from "../utils/request";

export function cmsCaigouOrder(data) {
    return request({
        url: "/shippingOrder/cmsCaigouOrder",
        data: data,
    });
}

export function cmsHebinOrder(data) {
    return request({
        url: "/shippingOrder/cmsHebinOrder",
        data: data,
    });
}

export function cmsUpdateCost(data) {
    return request({
        url: "/shippingOrder/cmsUpdateCost",
        data: data,
    });
}

export function cmsAllYicaigou(data) {
    return request({
        url: "/shippingOrder/cmsAllYicaigouTwo",
        data: data,
    });
}

export function cmsSelShopOrder(data) {
    return request({
        url: "/shippingOrder/cmsSelShopOrder",
        data: data,
    });
}

export function cmsChaiOrder(data) {
    return request({
        url: "/shippingOrder/cmsChaiOrder",
        data: data,
    });
}

export function cmsUpdateSource(data) {
    return request({
        url: "/shippingOrder/cmsUpdateSource",
        data: data,
    });
}


export function cmsReturnOrder(data) {
    return request({
        url: "/shippingOrder/cmsReturnOrder",
        data: data,
    });
}

export function cmsDeliverGoods(data) {
    return request({
        url: "/shippingOrder/cmsDeliverGoods",
        data: data,
    });
}

export function cmsSelYiShopOrder(data) {
    return request({
        url: "/shippingOrder/cmsSelYiShopOrder",
        data: data,
    });
}

export function cmsUpdateOrderZhuihui(data) {
    return request({
        url: "/shippingOrder/cmsUpdateOrderZhuihui",
        data: data,
    });
}

export function cmsUpdateOrder(data) {
    return request({
        url: "/shippingOrder/cmsUpdateOrder",
        data: data,
    });
}


export function cmsUpdateRemark(data) {
    return request({
        url: "/shippingOrder/cmsUpdateRemark",
        data: data,
    });
}



export function cmsTongbubendi(data) {
    return request({
        url: "/shippingOrder/cmsTongbubendi",
        data: data,
    });
}

export function piliangDeliverGoods(data) {
    return request({
        url: "/shippingOrder/piliangDeliverGoods",
        data: data,
    });
}

export function cmsProductRecordList(data) {
    return request({
        url: "/shippingOrder/cmsProductRecordList",
        data: data,
    });
}
